import { Component, inject, Input, OnInit } from '@angular/core';
import { Dc3Topic, Topic } from '../../../data/topic/topic';
import { TopicRepository } from '../../../data/topic/topic.repository';
import { AlertController, ModalController, PopoverController } from '@ionic/angular';
import { EntryRepository } from '../../../data/entry/entry.repository';
import { take } from 'rxjs';
import { defaultTopicColors } from '../../../tools/colors';
import { Tables } from '../../../data/database.types';
import { TopicApi } from '../../../data/topic/topic.api';

@Component({
  selector: 'app-topic-edit',
  templateUrl: './topic-edit.component.html',
  styleUrls: ['./topic-edit.component.scss']
})
export class TopicEditComponent implements OnInit {
  popoverController = inject(PopoverController);
  private topicRepository = inject(TopicRepository);
  private topicApi = inject(TopicApi);

  @Input() topic: Topic | undefined;

  colors = defaultTopicColors;


  ngOnInit() {
  }

  toggleRangeTracker($event: any, topic: Topic) {
    if (!topic.range_target) {
      topic.range_target = 'HIGH';
    } else {
      topic.range_target = null;
    }
  }

  updateRangeTarget(event: any, topic: Topic) {
    if (topic.range_target) {
      topic.range_target = event.detail.value;
    }
  }

  // deleteTopic() {
  //   if (this.topic) {
  //     this.entryRepository.getEntriesByTopic$(this.topic)
  //       .pipe(take(1)).subscribe(entriesToDelete => {
  //       this.alertController.create({
  //         header: 'Topic wirklich löschen?',
  //         message: `Möchten sie wirklich das Thema '${this.topic?.name}' mit allen ${entriesToDelete.length} Einträgen und Trackings löschen?`,
  //         buttons: ['Abbrechen', {
  //           text: 'Löschen',
  //           handler: () => {
  //             if (this.topic) {
  //               this.entryRepository.deleteEntries(entriesToDelete);
  //               this.topicRepository.deleteTopics([this.topic]);
  //               this.popoverController.dismiss();
  //             }
  //           }
  //         }]
  //       }).then(alert => alert.present());
  //     });
  //   }
  // }

  saveAndClose() {
    if (this.topic) {
      console.log(this.topic);
      this.topicApi.update(this.topic.id, this.topic);
      this.popoverController.dismiss();
    }
  }
}
